import axiosTraza from "global/helpers/axiosTraza";
import { SET_IDTIPO_PUNTOCONTROL } from "../ActionTypes";

export const wsPostTrazaPuntoControl = (dto) => (nextStep) => {
  axiosTraza().then((respuesta) => {
    respuesta
      .post("PuntoControl", dto)
      .then((resp) => {
        if (nextStep) nextStep(true, resp);
      })
      .catch((err) => {
        if (nextStep) nextStep(true, err);
      });
  });
};

export const setIdTipoPuntoControl = (idTipo) => (dispatch) => {
  dispatch({ type: SET_IDTIPO_PUNTOCONTROL, payload: idTipo });
};

export const resetIdTipoPuntoControl = () => (dispatch) => {
  dispatch({ type: SET_IDTIPO_PUNTOCONTROL, payload: null });
};

export const wsGetPuntoControlTexto =
  (idTipo, idRecepcion, idCentro) => (nextStep) => {
    axiosTraza().then((respuesta) => {
      respuesta
        .get(`/PuntoControlTexto/${idTipo}/${idRecepcion}/${idCentro}`)
        .then((resp) => {
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          if (nextStep) nextStep(true, err);
        });
    });
  };
